import state from './state';
import * as getters from './getters';
import * as mutations from './mutations';
import * as actions from './actions';

import medicationDSS from './questionnaires/medication-dss';
import clinicalAssessment from './questionnaires/clinical-assessment';

/**
 * Vuex store for Encounter
 *
 * @namespace vuex-Encounter
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.4] app/src/APP_DASHBOARD/store/encounter/index.js
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  namespaced: true,
  state,
  getters: {
    ...getters,
    ...medicationDSS.reduce((accumulator, currentValue) => ({
      ...accumulator,
      [currentValue.key]: (state) => state[currentValue.key],
      [currentValue.key + '_V1']: (state) => state[currentValue.key + '_V1'],
      [currentValue.key + '_V2']: (state) => state[currentValue.key + '_V2'],
    }), {}),
    ...clinicalAssessment.reduce((accumulator, currentValue) => ({
      ...accumulator,
      [currentValue.key]: (state) => state[currentValue.key],
      [currentValue.key + '_V1']: (state) => state[currentValue.key + '_V1'],
      [currentValue.key + '_V2']: (state) => state[currentValue.key + '_V2'],
    }), {}),
  },
  mutations: {
    ...mutations,
    ...medicationDSS.reduce((accumulator, currentValue) => ({
      ...accumulator,
      [`SET_${currentValue.key}`]: (state, value) => {
        Object.assign(state, { [currentValue.key]: value });
      },
      [`SET_${currentValue.key}_V1`]: (state, value) => {
        Object.assign(state, { [currentValue.key + '_V1']: value });
      },
      [`SET_${currentValue.key}_V2`]: (state, value) => {
        Object.assign(state, { [currentValue.key + '_V2']: value });
      },
    }), {}),
    ...clinicalAssessment.reduce((accumulator, currentValue) => ({
      ...accumulator,
      [`SET_${currentValue.key}`]: (state, value) => {
        Object.assign(state, { [currentValue.key]: value });
      },
      [`SET_${currentValue.key}_V1`]: (state, value) => {
        Object.assign(state, { [currentValue.key + '_V1']: value });
      },
      [`SET_${currentValue.key}_V2`]: (state, value) => {
        Object.assign(state, { [currentValue.key + '_V2']: value });
      },
    }), {}),
  },
  actions: {
    ...actions,
    ...medicationDSS.reduce((accumulator, currentValue) => ({
      ...accumulator,
      [`SET_${currentValue.key}`]: ({ commit }, value) => {
        commit(`SET_${currentValue.key}`, value);
      },
      [`SET_${currentValue.key}_V1`]: ({ commit }, value) => {
        commit(`SET_${currentValue.key}_V1`, value);
      },
      [`SET_${currentValue.key}_V2`]: ({ commit }, value) => {
        commit(`SET_${currentValue.key}_V2`, value);
      },
    }), {}),
    ...clinicalAssessment.reduce((accumulator, currentValue) => ({
      ...accumulator,
      [`SET_${currentValue.key}`]: ({ commit }, value) => {
        commit(`SET_${currentValue.key}`, value);
      },
      [`SET_${currentValue.key}_V1`]: ({ commit }, value) => {
        commit(`SET_${currentValue.key}_V1`, value);
      },
      [`SET_${currentValue.key}_V2`]: ({ commit }, value) => {
        commit(`SET_${currentValue.key}_V2`, value);
      },
    }), {}),
  },
};
